import * as creditApi from '@/network/api/credit.api.js'
import * as accountApi from '@/network/api/accounts.api.js'
import * as costumersApi from '@/network/api/customers/customers.api.js'

/** requests Products List
@return { Promise }
*/
export const requestproductsList = async (context, payload) => {
    const res = await creditApi.requestproductsList(payload)

    if (res) context.commit('SAVE_PRODUCTS_LIST', res.data.data)
    return res
}

/** requests plafonds for a credit product
@return { Promise }
*/
export const requestProductPlafond = async (context, payload) => {
    const res = await creditApi.requestProductPlafond(payload)

    if (res) context.commit('SAVE_PRODUCT_PLAFOND', res.data.data)
    return res
}

/** creates a credit account
@return { Promise }
*/
export const createCreditAccount = async (context, payload) => {
    const res = await creditApi.createCreditAccount(payload)
    return res
}

/** requests Accounts Balance
@return {promise} - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountApi.requestAccountsBalances(payload)
    if (res) context.commit('SAVE_ACCOUNTS_BALANCE', res.data.data)
    return res
}

/** validates client NIF
@return {promise}
*/
export const validateClientNif = async (context, payload) => {
    const res = await costumersApi.validateClientNif()
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearSubscribeProductStates = async (context, payload) => {
    context.commit('CLEAR_SUBSCRIBE_PRODUCTS_STATES')
}
